<script>
import Swal from '../../../js/sweetalert2.min.js';
import axios from 'axios';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';


export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            
            console.log("toss success")
            let uri = window.location.href.split('?');
            let vars = uri[1].split('&');
            var customerKey, authKey;

            for (var key in vars) { 
                var kv = vars[key];
                var kvArr = kv.split('=');
                var k = kvArr[0];
                var v = kvArr[1];
                if(k == 'customerKey'){
                    customerKey = v;
                } else if(k == 'authKey'){
                    authKey = v;
                } 
            }
            
            var form = new FormData();
            form.append('customerKey', customerKey);
            form.append('authKey',authKey);
            
            this.loginSuccess = false;
            Swal.showLoading();
            axios.post("/pay/tr1", form)
            
            .then(response => {  
                Swal.close();
                if(response.status == 200){
                    var msg;
                    var code = response.data.code;
                    
                    if(code == 10){
                        this.loginSuccess = true;
                        swal("멤버십 가입을 축하합니다.", {
                            icon: "success",
                        }).then(() => {
                            this.$router.push('/main/pc4?tab=membership')
                        });

                    } else if(code == 20){
                        swal("세션이 만료되었습니다.\n다시 로그인 해주세요.",).then(() => {
                            this.$router.push('/signin')
                        });
                    } else {
                        swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요." + code, {
                            icon: "info",
                        }).then(() => {
                            this.$router.push('/main/pc4?tab=membership')
                        });
                    }

                } else {
                    swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {
                        icon: "info",
                    }).then(() => {
                        this.$router.push('/main/pc4?tab=membership')
                    });

                }
            }).catch(error => {
                Swal.close();

                swal("마이파랑 서버에 연결할 수 없습니다.", "일시적인 장애이거나 네트워크 문제일 수 있습니다.\n 잠시 후 다시 이용해주세요.", {
                    icon: "info",
                }).then(() => {
                    this.$router.push('/main/pc4?tab=membership')
                });
            });
        }
    

    }
}
</script>



// WEBPACK FOOTER //
// src/components/pay/TossSuccess.vue